// hooks/useConsentListener.ts
import { useConsentStore } from "@/lib/stores/consentimiento-store";
import { useEffect } from "react";

export const useConsentListener = () => {
  const syncWithStorage = useConsentStore((state) => state.syncWithStorage);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "consent-storage" && event.newValue) {
        // Esperar un poco para asegurar que el cambio se procesó
        setTimeout(() => {
          syncWithStorage();
        }, 100);
      }
    };

    // Escuchar cambios en otras pestañas
    window.addEventListener("storage", handleStorageChange);

    // Polling para cambios en la misma pestaña (cada 2 segundos)
    const interval = setInterval(() => {
      syncWithStorage();
    }, 2000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, [syncWithStorage]);
};
